/**
 * Device identity port — web implementation.
 *
 * Browsers expose no stable hardware id, so a random id is minted once and kept
 * in local storage. Clearing site data yields a new device id, same as a reinstall.
 */
import { STORAGE_KEYS } from '../constants';
import { storage } from './storage';

const mintId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getDeviceId = async (): Promise<string> => {
  const cached = await storage.getItem<string>(STORAGE_KEYS.DEVICE_ID);
  if (cached) return cached;
  const generated = mintId();
  await storage.setItem(STORAGE_KEYS.DEVICE_ID, generated);
  return generated;
};

/** Lowercase form the auth mappers and refresh endpoint send. */
export const getDeviceTypeCode = (): string => 'browser';

/** Capitalized form the device-registration payload sends. */
export const getDeviceTypeLabel = (): string => 'Browser';
